import { Controller } from 'stimulus';

class CourseTable extends Controller {
  // eslint-disable-next-line class-methods-use-this
  onRowClick(event) {
    const row = event.target.closest('[role="row"]');

    if (!row) {
      throw new Error('Could not find row');
    }

    const collapseButton = row.querySelector('[aria-expanded]');

    if (!collapseButton) {
      throw new Error('Could not find collapse button');
    }

    const collapse = document.getElementById(collapseButton.getAttribute('aria-controls'));
    const isCollapsed = collapse.hidden;

    collapse[isCollapsed ? 'removeAttribute' : 'setAttribute']('hidden', 'hidden');
    collapseButton.setAttribute('aria-expanded', isCollapsed ? 'true' : 'false');
    row.classList[isCollapsed ? 'add' : 'remove']('is-expanded');
  }
}

CourseTable.targets = [
  //
];

export default CourseTable;
